import { replaceSubstring } from 'utils/common';

export const pasteCtnToString = (string, screenStr, newValue) => replaceSubstring(string, screenStr, newValue);
